<ng-container *ngIf="formArray">
  <div class="w-100">
    <app-response-search [limitToCampaignId]="campaignId"
                         [autoFocusDisabled]="autoFocusDisabled"
                         [isAdvancedResponseSelector]="true"
                         [tagCategoryIds]="[tagCategory.id]"
                         (itemSelected)="onTagSelected($event)">
      <ng-container *responseItemTmpl="let response = response">
        <mat-checkbox [checked]="isTagSelected(response)"
                      (change)="onTagCheckboxChanged($event, response)"
                      class="si-option d-block w-100 p-0">
          <div class="text">
            <div class="text__label break-word">{{response | tagSelectLabel}}</div>
            <!-- <div class="text__desc"></div> -->
          </div>
        </mat-checkbox>
      </ng-container>
      <ng-container *responseNoResultsTmpl>
        <ng-container *ngIf="!tagCategory.locked">
          <mat-list-item (click)="onAddNewResponseClick()"
                         class="d-block p-0075 pl-0100 color--blue c-pointer"
                         *appIfMinRole="getMinRole(tagCategory)">
            <i class="far fa-plus mr-0050 txt-14"></i>Add New Response
          </mat-list-item>
          <ng-container *ngIf="tagCategory.readonly">
            <mat-list-item *appIfInRole="['lead','organizer','activist']">
              No Results
            </mat-list-item>
          </ng-container>
        </ng-container>

        <div class="p-0075 pl-0100 color--gray"
             *ngIf="tagCategory.locked">
          No Results
        </div>
      </ng-container>
    </app-response-search>
    <div *ngIf="!tagCategory.locked"
         class="align--right">

      <button class="link pl-0 d-inline-block mt-0050 mb-0025"
              *appIfMinRole="getMinRole(tagCategory)"
              (click)="onAddNewResponseClick()">Create new response</button>

    </div>
  </div>

  <div class="ab-list-group mt-0075 mb-0050"
       *ngIf="formArray.controls.length > 0">
    <div class="ab-list-item d-flex flexWrap-nowrap mt-0 pt-0 pr-0 pb-0">
      <div class="w-100">
        <div class="pt-0075 pb-0075"><strong>Selected Responses To Apply</strong></div>
      </div>
    </div>
    <div class="ab-list-item d-flex flexWrap-nowrap mt-0 pt-0 pr-0 pb-0"
         *ngFor="let control of formArray.controls; index as i">
      <ng-container *ngIf="control.value?.selectedTag as selectedTag">
        <mat-icon fontSet="fal"
                  [fontIcon]="getTagIcon(selectedTag.tagType)"
                  class="color--turq txt-16 mt-0075 mr-0025"></mat-icon>
        <div class="w-100">
          <div class="pt-0075 pb-0025">
            <strong>{{selectedTag.name}} </strong>
          </div>

          <div [ngSwitch]="selectedTag.tagType">

            <app-shift-info-form *ngSwitchCase="'Shift'"
                                 [formControl]="control.get('shiftInfo')"
                                 class="d-block pb-0050">
            </app-shift-info-form>


            <mat-form-field class="col__"
                            *ngSwitchCase="'Notes'">
              <mat-label>Make a note</mat-label>
              <textarea matInput
                        [formControl]="control.get('note')"
                        matTextareaAutosize
                        matAutosizeMinRows="2"
                        matAutosizeMaxRows="5"
                        data-test-id="noteTagInput"></textarea>
            </mat-form-field>



            <mat-form-field class="col__"
                            *ngSwitchCase="'Date'">
              <mat-label>Date</mat-label>
              <input matInput
                     [matDatepicker]="datePicker"
                     placeholder="MM/DD/YYYY"
                     autocomplete="off"
                     [formControl]="control.get('note')"
                     name="date">
              <mat-datepicker-toggle matSuffix
                                     [for]="datePicker">
                <mat-icon fontSet="far"
                          fontIcon="fa-calendar"
                          matDatepickerToggleIcon></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #datePicker></mat-datepicker>
              <app-input-error [formControlItem]="control.get('note')"></app-input-error>
            </mat-form-field>

            <mat-form-field class="col__"
                            *ngSwitchCase="'Number'">
              <mat-label>Enter Number</mat-label>
              <input type="text"
                     [formControl]="control.get('note')"
                     matInput
                     decimalMask
                     data-test-id="numberInput" />
            </mat-form-field>

            <div *ngSwitchDefault></div>
          </div>

          <ng-container *ngIf="tagCategory.attachmentsEnabled">
            <app-file-selector class="d-block mb-0050"
                               *ngIf="!hideAttachments"
                               [compact]="true"
                               [file]="control.value?.file"
                               (fileChange)="setFile($event, control.get('file'))">
            </app-file-selector>
          </ng-container>

        </div>
        <button mat-icon-button
                (click)="removeTag(selectedTag)"
                aria-label="Remove"
                class="remove-item ml-auto">
          <mat-icon fontSet="far"
                    fontIcon="fa-times"></mat-icon>
        </button>
      </ng-container>
    </div>
  </div>


</ng-container>
